module.exports = __webpack_public_path__ + "img/home_32.3a37bc90.png";